<template>
  <div class="wrapper layout align-start nowrap mt-2" :style="commentLineStyle">
    <div v-if="comment.type === 'chat'" class="author">
      <v-avatar size="25px" style="background-color: var(--dark)">
        <span class="white--text">{{ comment.author | avatar }}</span>
      </v-avatar>
    </div>
    <div class="mx-2 ">
      <div class="content pa-2">
        {{ comment.text }}
      </div>
      <div class="meta layout align-center">
        <span v-if="comment.type === 'chat'">{{ comment.author }}</span>
        <span> &middot; </span>
        <span>{{ comment.createdAt | time }}</span>
      </div>
    </div>
    <v-spacer />
  </div>
</template>

<script>
import moment from 'moment';
export default {
  filters: {
    avatar: function(e) {
      return e.substring(0, 2).toUpperCase();
    },
    time: function(t) {
      return moment(t).fromNow();
    }
  },
  props: {
    comment: {
      type: Object
    }
  },
  computed: {
    byMe() {
      return this.comment.user === this.$store.state.user.me._id;
    },
    chooseSide() {
      return {
        alignSelf: this.byMe ? 'flex-start' : 'flex-end',
        flexDirection: this.byMe ? 'row-reverse' : 'row'
      };
    },
    commentLineStyle() {
      switch (this.comment.type) {
        case 'info':
          return {
            color: 'grey',
            fontSize: '.9em'
          };

        default:
          return this.chooseSide;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.meta {
  font-size: 0.8em;
  justify-self: end;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #787f8c;
  text-align: end;
}
.content {
  font-size: 1em;
  border-radius: 10px;
  background-color: #f5f5f5;
}
</style>
